import type { ComponentWithSource } from "../api/componentsData";

export function isTruthyFlag(value: unknown): boolean {
  return value === true || value === "true" || value === 1 || value === "1";
}

export function getAssignableFields(component: { fields?: unknown[] } | null | undefined) {
  const fields = Array.isArray(component?.fields) ? component!.fields : [];
  return fields.filter((field: any) => {
    const type = String(field?.type ?? "").toLowerCase();
    return field?.name && (type === "text" || type === "textarea");
  });
}

export function getDefaultAssignFieldName(component: { fields?: unknown[] } | null | undefined): string {
  const assignable = getAssignableFields(component);
  if (assignable.length === 0) return "";
  const quickDefault = assignable.find((field: any) => isTruthyFlag(field.quickDefault));
  if (quickDefault?.name) return String(quickDefault.name);
  const firstText = assignable.find((field: any) => String(field.type).toLowerCase() === "text");
  if (firstText?.name) return String(firstText.name);
  return String(assignable[0].name);
}

export function parseBooleanFieldValue(value: unknown): boolean | undefined {
  if (value === true || value === "true" || value === 1 || value === "1") return true;
  if (value === false || value === "false" || value === 0 || value === "0") return false;
  return undefined;
}

export function getCheckboxDefaults(fields: unknown[] | undefined): Record<string, boolean> {
  if (!Array.isArray(fields)) return {};
  return fields
    .filter((field: any) => field?.type === "checkbox")
    .reduce<Record<string, boolean>>((acc, field: any) => {
      const parsed = parseBooleanFieldValue(field?.value);
      if (parsed !== undefined && field?.name) {
        acc[field.name] = parsed;
      }
      return acc;
    }, {});
}

export function componentOptionLabel(component: ComponentWithSource): string {
  const name = component.name || component.slug || "Collection";
  const org = typeof component.organization === "string" ? component.organization.trim() : "";
  return org ? `${name} (${org})` : name;
}
